import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import { useAddNotification } from 'hooks/useAddNotification'
import { patch } from 'utils/http'

export const useCustomerEnrichApiConfigUpdate = () => {
  const customerId = useCustomerId()
  const addNotification = useAddNotification()
  const queryClient = useQueryClient()

  const { mutateAsync, ...rest } = useMutation({
    mutationFn: (payload: any) => patch(`/management/customers/${customerId}/enrich_api`, payload),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['customer', customerId, 'enrich_api_quota'] }),
        queryClient.invalidateQueries({ queryKey: ['customer', customerId, 'enrich_api_key'] }),
      ])
      addNotification('Enrich API config has been updated')
    },
    onError: () => addNotification('Enrich API config update error', 'error'),
  })

  return {
    updateEnrichApiConfig: mutateAsync,
    ...rest,
  }
}
